{
  "UnifiedNavigation": "在 Experience Cloud 中導覽",
  "adobeExperienceCloudNoOrgsSelect": "選取其他組織帳戶",
  "help": "說明",
  "ok": "確定",
  "profile": "基本資料",
  "searchButton": "搜尋",
  "sidenavMenuCloseTooltip": "關閉選單",
  "sidenavMenuLockTooltip": "按左鍵以鎖定功能表",
  "solutionSwitcher": "切換至其他解決方案",
  "themeCoachMark": "淺色主題",
  "themeCoachMarkMessage": "Experience Cloud 頁首現在支援淺色和深色主題。按一下您的頭像以切換您的偏好主題。",
  "toggleSideNav": "切換側邊導覽選單"
}
